import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=90a52736&scoped=true&lang=pug&"
var script = {}
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=90a52736&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a52736",
  null
  
)

export default component.exports